// Private.js
import React, { useEffect, useState } from "react";
import { Navigate } from 'react-router-dom';

const PrivateRoute = ({ element, redirectTo, ...rest }) => {
  // Utilisation de useState pour stocker l'état de connexion de l'utilisateur
  const [user, setUser] = useState({});
  const [loading, setLoading] = useState(true);

  // Utilisation de useEffect pour effectuer une requête au serveur et récupérer l'état de connexion
  useEffect(() => {
    fetch('/user/details-user')
      .then((response) => response.json())
      .then((data) => {
        setUser(data);
        setLoading(false); // Marquer la fin du chargement
      })
      .catch((error) => {
        console.error('Erreur requête :', error);
        setLoading(false); // Marquer la fin du chargement en cas d'erreur
      });
  }, []);


  // Si la requête est en cours, vous pouvez afficher un indicateur de chargement, par exemple.
  if (loading) {
    return <div>Loading...</div>;
  }

  // Condition ternaire : si l'utilisateur est connecté, affiche l'élément, sinon redirige vers la page spécifiée
  return user.mail ? element : <Navigate to={redirectTo} />;
};

export default PrivateRoute;
